module.exports = __webpack_public_path__ + "img/2010 winteressen 006.68a63708.jpg";